export const GRAMMAR_CLIP_STATUSES = ['pending', 'approved', 'rejected'] as const;
